import React from 'react';
import { CheckCircleIcon, XCircleIcon, ClockIcon } from '@heroicons/react/24/outline';

export default function BrainstormJobStatus({ jobId, progress, onCancel }) {
  const percent = progress?.percent ?? 0;
  const stage = progress?.stage || 'Queued…';
  const status = progress?.status || 'waiting';

  const isComplete = status === 'completed';
  const isFailed = status === 'failed';
  const isWaiting = status === 'waiting' || status === 'delayed';

  return (
    <div className="flex flex-col gap-4 py-2">
      {/* Status icon + stage */}
      <div className="flex items-center gap-3">
        {isComplete ? (
          <CheckCircleIcon className="h-6 w-6 text-green-500 shrink-0" />
        ) : isFailed ? (
          <XCircleIcon className="h-6 w-6 text-rose-500 shrink-0" />
        ) : isWaiting ? (
          <ClockIcon className="h-6 w-6 text-amber-400 shrink-0 animate-pulse" />
        ) : (
          <div className="h-6 w-6 rounded-full border-2 border-indigo-400 border-t-transparent animate-spin shrink-0" />
        )}
        <span className={`text-sm font-medium ${isFailed ? 'text-rose-600' : isComplete ? 'text-green-600' : 'text-gray-700'}`}>
          {stage}
        </span>
      </div>

      {/* Progress bar */}
      {!isFailed && (
        <div className="w-full h-2.5 rounded-full bg-gray-100 overflow-hidden">
          <div
            className="h-full rounded-full bg-gradient-to-r from-indigo-500 to-sky-400 transition-all duration-500"
            style={{ width: `${Math.min(100, percent)}%` }}
          />
        </div>
      )}

      {/* Percent label */}
      {!isFailed && (
        <div className="flex justify-between items-center text-xs text-gray-400">
          <span>{isWaiting ? 'Waiting in queue…' : `${percent}% complete`}</span>
          {isComplete && <span className="text-green-600 font-semibold">Done!</span>}
        </div>
      )}

      {/* Job ID badge */}
      {jobId && (
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-gray-400">Job ID:</span>
          <code className="text-xs bg-gray-100 text-gray-500 px-2 py-0.5 rounded font-mono select-all">{jobId}</code>
        </div>
      )}

      {/* Cancel button (only while active) */}
      {!isComplete && !isFailed && onCancel && (
        <button
          type="button"
          onClick={onCancel}
          className="self-start mt-1 text-xs text-gray-400 hover:text-rose-500 underline transition"
        >
          Cancel
        </button>
      )}
    </div>
  );
}
